<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre"><div class="pre" id="pre-004"><h1 class="pre_tit"><span><a id="page_13">Notes</a></span></h1><div class="dev"><p class="txt_courant_ssalinea"><a id="page_13"><b>Bible references </b>throughout are to the 1984 edition of the New International Version, unless indicated otherwise. The lower-case letters a, b, c, etc., refer to the lines within the verse in question.</a></p><p class="bl"><a id="page_13"> </a></p><p class="txt_courant_ssalinea"><a id="page_13"><b>The Divine Name. </b>In the Hebrew Old Testament, the personal name for the God of Israel was denoted by four Hebrew consonants, usually understood as expressing the form <i>Yahweh. </i>A strange scruple has, for the most part, prevented translators of the English Bible from using the Divine Name, adopting the convention of four upper-case letters, L<span class="small">ORD</span>, instead. The form ‘Lord’ represents a Hebrew noun (<i>’<span class="mev">ǎ</span>dōnāy</i>) meaning exactly that.</a></p><p class="bl"><a id="page_13"> </a></p><p class="txt_courant_ssalinea"><a id="page_13"><b>Inclusio. </b>Developments in our understanding of the structures of Hebrew poetry (see, e.g., E. R. Follis [ed.], <i>Directions in Biblical Hebrew Poetry </i>[Sheffield Academic Press, 1986]) have noted the feature called ‘inclusio’, meaning the ‘bracketing’ of a poem or stanza by identical words or matching thoughts.</a></p><p class="bl"><a id="page_13"> </a></p><p class="txt_courant_ssalinea"><a id="page_13"><b>The ‘square root’ sign </b>(√) is used as a convenient way of expressing the root form of Hebrew verbs, e.g. on 4:1, p. 66.</a></p></div></div></div><a id="page_13">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre5.vue?78c7fc1d